import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {dataStore} from 'core/redux/store';
import withCoreEvents from 'core/hocs/withCoreEvents';
import {StoreConnector} from './ui/StoreConnector';
import { setVersionHeartbeat } from 'core/api/generalService';

const App = (props) => {

  useEffect(() => {
    setVersionHeartbeat();
  }, []);

  return (
    <Provider store={dataStore}>
      <StoreConnector {...props} />
    </Provider>
  );
};
export default withCoreEvents(App);
